import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CasesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cases"}/>
}
